import React from 'react';
import Icon from '../../../components/AppIcon';

const TopFeaturesRanking = ({ features }) => {
  const getRankBadge = (rank) => {
    if (rank === 1) return 'bg-warning text-warning-foreground';
    if (rank === 2) return 'bg-muted text-foreground';
    if (rank === 3) return 'bg-accent/20 text-accent-foreground';
    return 'bg-muted/50 text-muted-foreground';
  };

  const getTrendIcon = (trend) => {
    if (trend === 'up') return { name: 'TrendingUp', color: 'text-success' };
    if (trend === 'down') return { name: 'TrendingDown', color: 'text-error' };
    return { name: 'Minus', color: 'text-muted-foreground' };
  };

  return (
    <div className="card h-full">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Top Features</h3>
        <Icon name="Award" size={20} className="text-primary" />
      </div>
      <div className="space-y-3">
        {features?.map((feature, index) => {
          const trendIcon = getTrendIcon(feature?.trend);
          return (
            <div
              key={feature?.name}
              className="p-4 bg-muted/20 rounded-lg hover:bg-muted/30 transition-smooth"
            >
              <div className="flex items-start gap-3">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${getRankBadge(index + 1)}`}>
                  <span className="text-sm font-bold font-data">{index + 1}</span>
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="text-sm font-semibold text-foreground truncate">
                      {feature?.name}
                    </h4>
                    <Icon name={trendIcon?.name} size={16} className={trendIcon?.color} />
                  </div>

                  <div className="flex items-center gap-4 text-xs">
                    <div className="flex items-center gap-1">
                      <Icon name="Users" size={12} className="text-muted-foreground" />
                      <span className="text-muted-foreground caption">
                        {feature?.users?.toLocaleString()}
                      </span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="Activity" size={12} className="text-muted-foreground" />
                      <span className="text-muted-foreground caption">
                        {feature?.engagement}%
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 h-1.5 bg-muted rounded-full overflow-hidden">
                    <div
                      className="h-full bg-gradient-to-r from-primary to-secondary transition-all duration-500"
                      style={{ width: `${feature?.engagement}%` }}
                    />
                  </div>

                  <div className="mt-2 flex items-center justify-between text-xs">
                    <span className="text-muted-foreground caption">
                      {feature?.category}
                    </span>
                    <span className={`font-semibold ${trendIcon?.color}`}>
                      {feature?.change}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <button className="w-full py-2 text-sm font-medium text-primary hover:text-primary/80 transition-smooth flex items-center justify-center gap-2">
          <span>View All Features</span>
          <Icon name="ArrowRight" size={16} />
        </button>
      </div>
    </div>
  );
};

export default TopFeaturesRanking;